import atoms from "../../../atoms";
import { AddRowProps, Eye, TLens } from "../interface";

const { Input } = atoms

export const AddRow = ({ lens, eye }: AddRowProps) => {
    // Sub-component for ADD row
    const getAddValue = (lens:TLens, eye: Eye) =>
        lens?.prescription_details?.[`${eye}_add`] || "";
    return (
        <div className="d-flex mt-2 gap-1">
            <div className="align-items-center d-flex col-2">
                <h4 className="fs-16 fw-600 secondary-color">{`ADD :`}</h4>
            </div>
            <div style={{ width: "110px" }}>
                <Input
                    type="text"
                    onChange={() => ""}
                    disabled={true}
                    value={getAddValue(lens, eye)}
                    placeholder=""
                />
            </div>
        </div>
    )
};